module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticClass: "mb-10",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    staticClass: "breadcrumb",
    attrs: {
      "span": 20
    }
  }, [_c('p', {
    staticClass: "dark"
  }, [(_vm.role !== 'student') ? _c('el-tag', {
    attrs: {
      "type": "success",
      "color": "white"
    }
  }, [_vm._v(_vm._s(!_vm.studentName ? '' : _vm.studentName))]) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.title) + "\n            ")], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-breadcrumb', {
    staticClass: "right breadcrumb",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": this.$route.query.reportIndex + ((_vm.role === 'teacher' || _vm.role === 'ta') ? '?studentId=' + _vm.studentId : '')
    }
  }, [_vm._v(_vm._s(_vm.reportName))]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("Evidence")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-10 p-10 bg-lightgary"
  }, [_c('h4', {
    staticClass: "mb-10"
  }, [_vm._v(_vm._s(_vm.skillAbbr) + " - " + _vm._s(_vm.pageName) + " - Evidence Checklist")]), _vm._v(" "), _c('p', [_vm._v("每条证据请以PDF的格式上传，并在Description中简要描述该证据是什么。")]), _vm._v(" "), ((_vm.skillAbbr === 'IOLP' && _vm.pageName === 'Preparation/Plan') || (_vm.skillAbbr === 'PRL' && _vm.pageName === 'Preparation')) ? _c('table', [_vm._m(0), _vm._v(" "), _vm._m(1)]) : (_vm.pageName === 'Do' && (_vm.skillAbbr === 'PRL' || _vm.skillAbbr === 'IOLP')) ? _c('table', [_vm._m(2), _vm._v(" "), _vm._m(3)]) : (_vm.pageName === 'Review' && (_vm.skillAbbr === 'PRL' || _vm.skillAbbr === 'IOLP')) ? _c('table', [_vm._m(4), _vm._v(" "), _vm._m(5)]) : (_vm.pageName === 'Explore' && (_vm.skillAbbr === 'PS' || _vm.skillAbbr === 'TP')) ? _c('table', [_vm._m(6), _vm._v(" "), _vm._m(7)]) : (_vm.pageName === 'Plan/Do' && (_vm.skillAbbr === 'PS' || _vm.skillAbbr === 'TP')) ? _c('table', [_vm._m(8), _vm._v(" "), _vm._m(9)]) : (_vm.pageName === 'Review' && (_vm.skillAbbr === 'PS' || _vm.skillAbbr === 'TP')) ? _c('table', [_vm._m(10), _vm._v(" "), _vm._m(11)]) : (_vm.pageName === 'Planning' && (_vm.skillAbbr === 'R' || _vm.skillAbbr === 'RS')) ? _c('table', [_vm._m(12), _vm._v(" "), _vm._m(13)]) : (_vm.pageName === 'Carrying out the research' && (_vm.skillAbbr === 'R' || _vm.skillAbbr === 'RS')) ? _c('table', [_vm._m(14), _vm._v(" "), _vm._m(15)]) : (_vm.pageName === 'Presentation' && (_vm.skillAbbr === 'R' || _vm.skillAbbr === 'RS')) ? _c('table', [_vm._m(16), _vm._v(" "), _vm._m(17)]) : ((_vm.skillAbbr === 'WWO' && _vm.pageName === 'Preparation/Plan') || (_vm.skillAbbr === 'TW' && _vm.pageName === 'Preparation')) ? _c('table', [_vm._m(18), _vm._v(" "), _vm._m(19)]) : (_vm.pageName === 'Do' && (_vm.skillAbbr === 'WWO' || _vm.skillAbbr === 'TW')) ? _c('table', [_vm._m(20), _vm._v(" "), _vm._m(21)]) : (_vm.pageName === 'Review' && (_vm.skillAbbr === 'WWO' || _vm.skillAbbr === 'TW')) ? _c('table', [_vm._m(22), _vm._v(" "), _vm._m(23)]) : (_vm.skillAbbr === 'D') ? _c('table', [_vm._m(24), _vm._v(" "), _vm._m(25)]) : (_vm.skillAbbr === 'OP') ? _c('table', [_vm._m(26), _vm._v(" "), _vm._m(27)]) : _vm._e()]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.evidences,
      "empty-text": "No data",
      "default-expand-all": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.templateType === 1) ? _c('ul', {
          staticClass: "el-upload-list el-upload-list--picture-card"
        }, _vm._l((scope.row.answerList), function(answer, index) {
          return _c('li', {
            key: index,
            staticClass: "el-upload-list__item is-success",
            on: {
              "click": function($event) {
                return _vm.handlePictureCardPreview(answer)
              }
            }
          }, [_c('img', {
            staticClass: "el-upload-list__item-thumbnail",
            attrs: {
              "src": answer.thumb,
              "alt": ""
            }
          }), _vm._v(" "), _c('span', {
            staticClass: "el-upload-list__item-actions"
          }, [_c('span', {
            staticClass: "el-upload-list__item-preview"
          }, [_c('i', {
            staticClass: "el-icon-view"
          })])])])
        }), 0) : (scope.row.templateType === 0) ? _vm._l((scope.row.answerList), function(answer) {
          return _c('a', {
            attrs: {
              "href": answer.url,
              "target": "_blank"
            }
          }, [_c('img', {
            staticClass: "pdfIcon",
            attrs: {
              "src": require("../../assets/pdf_icon.jpg"),
              "alt": ""
            }
          })])
        }) : (scope.row.templateType === 2) ? _c('a', {
          attrs: {
            "href": _vm.tryAddProtocol(scope.row.answerList.length === 0 ? '' : scope.row.answerList),
            "target": "_blank"
          }
        }, [_vm._v("\n                            " + _vm._s(scope.row.answerList.length === 0 ? '' : scope.row.answerList) + "\n                        ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sequence",
      "label": "Seq",
      "width": "65",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "description",
      "label": "Description",
      "min-width": "125"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "templateType",
      "label": "Type",
      "min-width": "155",
      "formatter": _vm.getTemplateText
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "time",
      "label": "CreatedDate",
      "min-width": "125"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Confirmed",
      "min-width": "125"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.confirmed) ? _c('i', {
          staticClass: "el-icon-success",
          staticStyle: {
            "color": "#67C23A"
          }
        }) : _c('i', {
          staticClass: "el-icon-error",
          staticStyle: {
            "color": "#F56C6C"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actions",
      "width": "180",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button-group', [_c('el-button', {
          staticClass: "p-5",
          attrs: {
            "type": "primary",
            "icon": "el-icon-edit",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.showDialog(scope.row.templateType, scope.$index, scope.row.confirmed)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          staticClass: "p-5",
          attrs: {
            "type": "danger",
            "icon": "el-icon-delete",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleDeleteEvidence(scope.$index, scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          staticClass: "p-5",
          attrs: {
            "type": "success",
            "icon": "el-icon-arrow-up",
            "size": "mini",
            "disabled": scope.$index == 0
          },
          on: {
            "click": function($event) {
              return _vm.handleMoveOrder(-1, scope.row.sequence, scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          staticClass: "p-5",
          attrs: {
            "type": "success",
            "icon": "el-icon-arrow-down",
            "size": "mini",
            "disabled": scope.$index == _vm.evidences.length - 1
          },
          on: {
            "click": function($event) {
              return _vm.handleMoveOrder(1, scope.row.sequence, scope.row)
            }
          }
        })], 1)]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "mb-50"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-dropdown', {
    staticClass: "mt-10 mb-10",
    attrs: {
      "placement": "top-start"
    },
    on: {
      "command": _vm.addEvidence
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("\n                    Add more evidence "), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isBtnClick),
      expression: "isBtnClick"
    }],
    staticClass: "evidence-Dropdown",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "0"
    }
  }, [_vm._v("PDF")]), _vm._v(" "), ((this.skillAbbr === 'TW' && this.pageName === 'Review') || (this.skillAbbr === 'WWO' && this.pageName === 'Review')) ? _c('el-dropdown-item', {
    attrs: {
      "command": "3"
    }
  }, [_vm._v("Peer/Witness statement")]) : _vm._e(), _vm._v(" "), (this.skillAbbr === 'D') ? _c('el-dropdown-item', {
    attrs: {
      "command": "4"
    }
  }, [_vm._v("Observation checklist")]) : _vm._e(), _vm._v(" "), (this.skillAbbr === 'OP') ? _c('el-dropdown-item', {
    attrs: {
      "command": "5"
    }
  }, [_vm._v("Observation checklist")]) : _vm._e(), _vm._v(" "), (this.skillAbbr === 'ISP' && this.pageName === 'Evaluating Presentation') ? _c('el-dropdown-item', {
    attrs: {
      "command": "6"
    }
  }, [_vm._v("Observation checklist")]) : _vm._e()], 1)], 1), _vm._v(" "), (this.templateName !== '') ? _c('a', {
    staticClass: "white",
    attrs: {
      "href": this.templateHref
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    }
  }, [_c('i', {
    staticClass: "icon ion-android-download"
  }), _vm._v(" " + _vm._s(_vm.templateName) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), (this.templateName1 !== '') ? _c('a', {
    staticClass: "white",
    attrs: {
      "href": this.templateHref1
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    }
  }, [_c('i', {
    staticClass: "icon ion-android-download"
  }), _vm._v(" " + _vm._s(_vm.templateName1) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.role === 'teacher' || _vm.role === 'ta') ? _c('el-button', {
    attrs: {
      "type": "success",
      "plain": ""
    },
    on: {
      "click": _vm.confirmAll
    }
  }, [_vm._v("Confirm All")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('evidence-dialog', {
    ref: "evidenceDialog",
    attrs: {
      "userId": _vm.userId,
      "studentId": _vm.studentId
    },
    on: {
      "saved": _vm.getEvidences,
      "confirmed": _vm.getEvidences,
      "disapproved": _vm.getEvidences
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.picReview,
      "width": "90%",
      "customClass": "dialogWidth-1000",
      "title": "Preview",
      "modal": true
    },
    on: {
      "update:visible": function($event) {
        _vm.picReview = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    ref: "pdfPreview",
    attrs: {
      "target": "_blank"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("1. Action Plan(You can download Action Plan Template below);")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("1.个人行动计划（系统中有模板可下载：Action Plan Template）；")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("1. Revised Action Plan; ")]), _c('span', [_vm._v("2. Time management Evidence")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("1. 修改后的个人行动计划；")]), _c('span', [_vm._v("2. 时间管理的证据，比如时间表，时间管理软件截屏等。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("Result of each target")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("根据Plan部分的measurement确定的三个SMART Target完成结果的证据（每个目标至少1个），比如有资格的成人的反馈（如老师，教练，父母等，"), _c('span', [_vm._v("不可以是同学或朋友的反馈")]), _vm._v("），成绩单等。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("Evidence of finding three options; ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("展示如何发现问题解决方案的证据，比如展示思考解决方案过程的思维导图（mind map），与别人讨论解决方案的记录（培训中使用的interview sheets），上网搜索解决方案的截屏或等。 ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("1. Action Plan;")]), _vm._v(" "), _c('span', [_vm._v("2. Evidence showing process of problem solving.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("1.个人行动计划")]), _c('span', [_vm._v("2.展示三个sub-problem解决过程的证据，比如记录解决过程的视频，音频，照片，笔记等。 ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("Result of each sub-problem")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("根据Plan部分制定的checking method确定的三个sub-problem解决结果的证据（每个sub-problem至少1个），比如有资格的成人给你的反馈（如老师，教练，父母等，"), _c('span', [_vm._v("不可以是同学或朋友的反馈")]), _vm._v("），评分表结果等。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("Action Plan(You can download Action Plan Template below)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("个人行动计划（系统中有模板可下载：Action Plan Template）")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("1. Evidence of Secondary Research; ")]), _c('span', [_vm._v("2. Evidence of Primary Research.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("1.展示二手调研过程的证据，如网页截屏，网页链接，读书笔记，查阅资料的整理等；")]), _c('span', [_vm._v("2.展示一手调研过程的证据，如采访照片，采访稿，调查问卷，实地考察的照片等。一共要提供使用至少三种不同调研方式的证据。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("1. Evidence showing information analysis; ")]), _c('span', [_vm._v("2. Research Paper (800 English words); ")]), _c('span', [_vm._v("3. PPT; ")]), _c('span', [_vm._v("4. Feedback from others (tutors, parents and other qualified adults) to your research findings.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("1.展示对搜集到的信息进行分析的证据，如问卷调查结果的统计和分析图表，采访结果的整理和分析笔记等；")]), _c('span', [_vm._v("2.调研报告（不少于800英文单词）；")]), _c('span', [_vm._v("3.PPT；")]), _c('span', [_vm._v("4.别人对你调研结果，如调研报告，PPT和分析图表等的反馈，必须是有资格的成年人，如老师等的反馈。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence:"), _c('span', [_vm._v("1. Team Action Plan(You can download Team Action Plan Template below); ")]), _c('span', [_vm._v("2. Personal Action Plan(You can download Personal Action Plan Template below); ")]), _c('span', [_vm._v("3. First Team Meeting Minute; ")]), _c('span', [_vm._v("4. First Team Meeting Photos.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("1.团队行动计划（系统中有模板可下载：Team Action Plan Template），每个团队一份；")]), _c('span', [_vm._v("2.个人根据自己的分工制定的个人行动计划（系统中有模板可下载：Personal Action Plan Template）；")]), _c('span', [_vm._v("3.第一次团队会议记录；")]), _c('span', [_vm._v("4.第一次团队会议照片。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("1. Evidence of carrying out personal action plan; ")]), _c('span', [_vm._v("2. Evidence showing personal contribution to the team; ")]), _c('span', [_vm._v("3.Second Team Meeting Minute; ")]), _c('span', [_vm._v("4. Second Team Meeting Photos.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("1.个人完成根据自己分工制定的个人行动计划的证据，比如负责财务管理的同学，需要提供财务预算表，每一笔开支的记录，查找并选择省钱的出行或就餐方案的网页截屏，每一笔花销的收据，制定的决算表等；")]), _c('span', [_vm._v("2.个人对团队贡献的证据，比如帮助解决团队分歧的证据，帮助团队成员完成任务的证据，充分利用团队时间的证据等；")]), _c('span', [_vm._v("3. 第二次团队会议记录；")]), _c('span', [_vm._v("4.第二次团队会议照片。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("1. Team Video (at least 4 minutes);")]), _c('span', [_vm._v(" 2. Peer Statement; ")]), _c('span', [_vm._v("3. Third Team Meeting Minute and Photos (if any).")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("1.展示团队合作过程的视频（至少4分钟）；")]), _c('span', [_vm._v("2.一位团队成员对你团队合作中表现的评价表（系统中有模板可以下载：Peer Statement）")]), _c('span', [_vm._v("3.第三次团队会议记录及照片（如有）。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("1. Prepared materials for the topic to be discussed;")]), _c('span', [_vm._v(" 2. Photos of discussion; ")]), _c('span', [_vm._v("3. Notes taken down during discussion; ")]), _c('span', [_vm._v("4. Observation Checklist from ASDAN tutor;  ")]), _c('span', [_vm._v("5. Feedback from group members in trial round of discussion.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("1.为讨论的主题准备的材料，比如上网搜索的相关信息的截屏或链接，查阅的资料的照片或记录的笔记；")]), _c('span', [_vm._v("2.小组讨论的照片；")]), _c('span', [_vm._v("3.讨论过程中做的笔记的照片；")]), _c('span', [_vm._v("4.ASDAN老师对你讨论过程中表现的评价表；")]), _c('span', [_vm._v("5.模拟讨论时同学给你的反馈。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("1.PPT; ")]), _c('span', [_vm._v("2.Notes for presentation; ")]), _c('span', [_vm._v("3.Practice photos or videos; ")]), _c('span', [_vm._v("4. Other preparations for presentation; ")]), _c('span', [_vm._v("5.Observation Checklist from ASDAN Tutor; ")]), _c('span', [_vm._v("6. Feedback from group members in presentation practice.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("1.Research技能中做的PPT；")]), _c('span', [_vm._v("2.在演讲中给自己提词的笔记，演讲结构纲要等；")]), _c('span', [_vm._v("3. 做演讲练习时的照片或视频；")]), _c('span', [_vm._v("4.为演讲做的其他准备，比如学习名人演讲所看的网上视频的截屏，在网上查找的演讲技巧的笔记照片等；")]), _c('span', [_vm._v("5.ASDAN老师对你演讲过程中表现的评价表；")]), _c('span', [_vm._v("6.模拟演讲/演讲练习时同学给你的反馈。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35d65550"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/student/Evidence.vue
// module id = 608
// module chunks = 1